export default {
	'changeAnswer': 'Изменить ответ',
	'variables': 'Переменные',
	'variablesList': 'Список переменных',
	'autoAnswers': 'Автоматические ответы',
	'download': 'Загрузить файлы',
	'addTicket': "Добавить заказ",
	'addTask': "Добавить задачу",
	'addTag': "Добавить Тег",
	'from': "От",
	'to': 'До',
	'reset': "Сбросить",
	'searchByNameAndClient': "Поиск по названию и клиенту",
	'searchByCid': 'Поиск по CID',
	'save': "Сохранить",
	'cancel': "Отмена",
	'chooseDate': "Выберите дату",
	'description': "Описание",
	'taskView': "Описание задачи",
	'date': "Дата",
	'ticket': "Заказ",
	'setByAdmin': "Важно!",
	'delete': "Удалить",
	'done': "Выполнено",
	'notDone': "Не выполнено",
	'completedSuccessfully': "Успешно выполнено",
	'addedSuccessfully': "Успешно добавлено",
	'changedSuccessfully': "Успешно изменено",
	'deletedSuccessfully': "Успешно удалено",
	"causedBy": "Тип проблемы",
	'name': "Название",
	'subject': "Предмет",
	'type': "Тип",
	'pagesCount': "Страниц",
	'reasonFailed': 'Причина провала',
	'milestonesCount': "Этапов",
	'priceEuro': "Цена, €",
	'dueDate': "Дедлайн",
	'manager': "Менеджер",
	'comment': "Комментарий",
	'client': "Клиент",
	'level': "Уровень",
	'author': "Автор",
	'task': "Задачи",
	'new': "Новые",
	'clientNotAnswer': "Без ответа",
	'processing': "В обработке",
	'waitingPayment': "Ожидает оплаты",
	'waitingAuthor': "В поиске исполнителя",
	'inProgress': "В процессе",
	'waitingApprove': "Подтверждается",
	'completed': "Выполнено",
	'failedWithPayout': "Провалено (гонорар выпл.)",
	'failed': "Провалено",
	'basket': 'Корзина',
	'promocode': "Промокод",
	'confirmUnblockingOrder': "Подтвердите восстановление заказа",
	'orderRestoredSuccessfully': "Заказ успешно восстановлен",
	'confirmBlockingUser': "Подтвердите блокировку клиента",
	'confirmUnblockingUser': "Подтвердите разблокировку клиента",
	'ban_clients': "Заблокированные клиенты",
	'user_banned_successfully': "Клиент успешно заблокирован",
	'user_unbanned_successfully': "Клиент успешно разблокирован",
	'confirmBlocking': "Подтвердите блокировку",
	'confirmUnblocking': "Подтвердите разблокировку",
	'createOrder': "Создание заказа",
	'newtonsLaw ': "Закон Ньютона",
	'clientsEmail': "E-Mail клиента",
	'site': "Сайт",
	'subjectArea': "Предмет",
	'workType': "Тип работы",
	'qualityLevel': "Уровень качества",
	'pagesAmount': "Количество страниц",
	'workLanguage': "Язык выполнения",
	'language': "Язык",
	'loadFile': "Загрузить файл",
	'create': "Создать",
	'orderWasCreatedSuccessfully': "Заказ успешно создан",
	'order': "Заказ",
	'currentOrderStatus': "Текущий статус заказа",
	'price': "Цена",
	'refuseWork': "Отказаться от заказа",
	'message': "Cообщение",
	'writeMessage': "Написать сообщение",
	'invitesWasSent': "Приглашения отправлены",
	'youMarkedOrderAs': "Вы отметили заказ как",
	'confirmAction': "Подтвердите действие",
	'agree': "Начать заказ",
	'youWantToMarkOrderAs': "Вы собираетесь отметить заказ как",
	'totalWorks': "Всего заказов",
	'currentWorks': "Текущих заказов",
	'currentVsLimit': 'Текущие / Лимит',
	'favorites': "Избранные",
	'invite': "Пригласить",
	'performersRequests': "Заявки исполнителей",
	'select': "Выбрать",
	'selectTags': 'Выберите теги',
	'selectReason': 'Выберите причину',
	'yourRequestsWasSentSuccessfully': "Ваши приглашения были успешно отпралены",
	'youHaveAssignedAuthorToThisProject': "Вы назначили автора на этот заказ",
	'thanksWeReceivedYourRequest': "Спасибо, мы получили вашу заявку",
	'managerWillConfirmItSoon': "Менеджер скоро ее подтвердит",
	'pleaseWait': "Пожалуйста, подождите",
	'paymentDetails': "Детали оплаты",
	'details': "Доп. детали",
	'client_file': 'Файл от клиента',
	'stage': "Этап",
	'priceForClient': "Цена для клиента",
	'priceForNative': "Цена для Native",
	'priceForJuniorAndMiddle': "Цена для Middle",
	'priceForSenior': "Цена для Senior",
	'pagesAmountShort': "Кол-во страниц",
	'loadPhoto': "Загрузить фото",
	'recommendedPaymentSum': "Рекомендуемая сумма к оплате",
	'totalPaymentSum': "Всего сумма к оплате",
	'lowerThanRecommendedSum': "Сумма меньше рекомендуемой",
	'addStage': "Добавить этап",
	'sendForApproval': "Отправить на утверждение",
	'edit': "Редактировать",
	'approve': "Утвердить",
	'firstlyAddWorkTypeToOrder': "Выберите тип работы",
	'youConfirmedPaymentSuccessfully': "Вы успешно подтвердили оплату",
	'dataWasSentToClientForApproval': "Файлы отправлены клиенту",
	'dataWasSentForApproval': "Документ отправлен на утверждение",
	'youMarkedStageAs': "Вы отметили этап как",
	'stageWasMovedToStatus': "Изменение статуса заказа:",
	'payRewardToAuthor': "Выплатить гонорар автора",
	'authorsReward': "Сумма выплат",
	'failureType': 'Категория провала',
	'pay': "Выплатить",
	'doCancel': "Отменить",
	'indicateFailureReason': "Укажите причину провала",
	'orderClosureStatus': 'Статус закрытия заказа',
	'closeOrder': 'Закрыть заказ',
	'informationAboutOrder': "Информация о заказе",
	'workTheme': 'Тема работы',
	'workName': "Тема",
	'workLongTerm': 'Долгосрочная работа',
	'clientsComment': "Комментарий клиента",
	'recommendedSumShort': "Реком. сумма",
	'add': "Добавить",
	'attachedFiles': "Прикрепленные файлы | Прикрепленный файл | Прикрепленные файлы | Прикрепленные файлы",
	'paymentMethod': "Способ оплаты",
	'filesFromAuthor': "Файлы от автора",
	'filesFromClient': 'Файлы от Клиента',
	'send': "Отправить",
	'firstEmailReply': "Отправить первое сообщение",
	'sendAutomatically': "Отправлять автоматически",
	'filesWasSentToClient': "Файлы были отправлены клиенту",
	'notAllowedFileType': 'Этот тип файла запрещен для загрузки.',
	'refuse': "Отказаться",
	'youWantToCompleteOrder': "Вы собираетесь завершить заказ",
	'thisActionIsIrreversible': "Данное действие необратимо",
	'completeOrder': "Завершить заказ",
	'orderIsCompletedSuccessfully': "Заказ успешно завершен",
	'writeToManager': "Написать менеджеру",
	'discuss': "Обсуждается",
	'creationDate': "Дата создания",
	'calculatedSum': "Расчетная цена",
	'includingVAT': "включая НДС",
	'assign': "Назначить",
	'chooseManager': "Выберите менеджера",
	'passwordRecovery': "Восстановление пароля",
	'enterYourEmailAndWeWillSendYouNewPassword': "Введите свой email и мы отправим вам новый пароль",
	'recoverPassword': "Восстановить пароль",
	'toLoginPage': "На страницу входа",
	'newPasswordIsGeneratedAndSentToMail': "Новый пароль отправлен на почту",
	'registration': "Регистрация",
	'fillFormBelowToCreateNewAccount': "Заполните форму ниже, чтобы создать новую учетную запись",
	'youAreAlreadyLoggedIn': "Вы уже вошли в систему!",
	'entrance': "Вход",
	'welcomeBack': "С возвращением",
	'pleaseLoginToYourAccount': "Пожалуйста, войдите в свой аккаунт",
	'password': "Пароль",
	'repeatPassword': "Повторите пароль",
	'newPassword': "Новый пароль",
	'yes': "Да",
	'no': "Нет",
	'confirmDeletion': "Подтвердите удаление",
	'doYouWantToDelete': "Вы собираетесь удалить",
	'registrationLinkCreation': "Создание ссылки для регистрации",
	'linkToRegistrationForm': "Ссылка на форму регистрации",
	'generate': "Сгенерировать",
	'close': "Закрыть",
	'nickname': "Никнейм",
	'emailForPayment': "SEPA/SWIFT IBAN",
	'phone': "Телефон",
	'sex': "Пол",
	'country': "Страна",
	'birthDate': "Дата рождения",
	'surname': "Фамилия",
	'profile': "Профиль",
	'subjects': "Предметы",
	'undesirableSubjects': 'Нежелательные дисциплины',
	'aboutYourself': "О себе",
	'dataIsSaved': "Данные сохранены",
	'totalOrdersCount': "Общее количество заказов",
	'success': "Успешность",
	'personName': "Имя",
	'changeWorkType': "Изменить тип работы",
	'shortRussian': "рус",
	'shortGerman': "нем",
	'totalTicketsAmount': "Общее количество заказов",
	'activatedTickets': "Активных заказов",
	'income': "Доход",
	'totalIncome': "Общий доход",
	'clientEditing': "Редактирование клиента",
	'additionalEmail': "Дополнительный Email",
	'activatedOrder': "Активных заказов",
	'changingManagerRequest': "Запрос на смену менджера",
	'newManager': "Новый менеджер",
	'confirm': "Подтвердить",
	'decline': "Отклонить",
	'firstlySelectManager': "Нужно сначала указать менеджера",
	'changingManagerRequestIsSent': "Отправлен запрос на смену менеджера",
	'requestWasDeclined': "Запрос был отменен",
	'searchByName': "Поиск по имени",
	'searchByPhone': 'Поиск по телефону',
	'actions': "Действия",
	'removalOrderReason': "Причина удаления заказа",
	'orderAddedToBasket': "Заказ перемещен в корзину",
	'totalOrders': "Всего заказов",
	'paidOrder': "Оплаченные",
	'hangingOrders': 'Повисшие',
	'sitesPreferences': "Настройки для сайтов",
	'managerEditing': "Редактирование менеджера",
	'managerCreating': "Создание менеджера",
	'sitesSettings': "Настройки сайта",
	'basicPrices': "Базовые цены",
	'workTypesVisibility': "Видимость типов работ",
	'invoicesData': "Данные для инвойсов",
	'changesIsSavedSuccessfully': "Изменения успешно сохранены",
	'siteWasCreatedSuccessfully': "Сайт был успешно создан",
	'managersFee': "Гонорар менеджера",
	'deleteLogo': "Удалить лого",
	'firmInfo': "Информация о фирме",
	'termsAndConditions': "Условия и положения",
	'part': "часть",
	'changeLogo': "Изменить лого",
	'mainColor': "Основной цвет",
	'additionalColor': "Дополнительный цвет",
	'showForJunior': "Показать для Junior",
	'showForMiddle': "Показать для Middle",
	'showForSenior': "Показать для Senior",
	'general': "Общая",
	'bySites': "По сайтам",
	'openDiscuss': "Открыть обращение",
	'opened': "Открытые",
	'number': "Номер",
	'discussTheme': "Тема обращения",
	'status': "Статус",
	'order_limit': 'Лимит заказов',
	'lastAnswer': "Последний ответ",
	'answerReceived': "Ответ получен",
	'waitingToAnswer': "Ожидает ответа",
	'closed': "Закрытые",
	'isClosed': "Закрыто",
	'openNewDiscuss': "Открыть новое обращение",
	'discussText': "Текст обращения",
	'doYouWantToCloseDiscuss': "Вы собираетесь закрыть обращение",
	'closeDiscuss': "Закрыть обращение",
	'aDiscuss': "Обращение",
	'discussStatus': "Статус обращения",
	'write': "Написать",
	'techSupport': "Тех.поддержка",
	'pendingConsideration': "Ожидает рассмотрения",
	'paidOut': "Выплачено",
	'rejected': "Отклонено",
	'payRequest': "Вывод средств",
	'writeHowMuchYouWantToWithdraw': "Укажите какую сумму Вы хотите вывести",
	'pleaseFillPaymentDetails': 'Операция вывода запрещена, заполните данные для оплаты.',
	'rejectPayment': "Отклонить платеж",
	'paymentRejectingReason': "Причина отклонения платежа",
	'currentBalance': "Текущий баланс",
	'withdraw': "Вывести",
	'rejectSuccessfully': "Успешно отклонено",
	'idTransaction': "ID транзакции",
	'sum': "Сумма",
	'paymentSystem': "Платежная система",
	'paymentRequests': "Запросы на выплату",
	'paymentsHistory': "История выплат",
	'accrualHistory': "История зачислений",
	'ordersHistory': "История заказов",
	'user': "Пользователь",
	'rejectedPayments': "Отклоненные выплаты",
	'addWorkType': "Добавить тип работы",
	'responseText': "Текст ответа",
	'addAnswer': "Добавить ответ",
	'ago': "назад",
	'month(1)': "месяц",
	'month(2-5)': "месяца",
	'month(6-0': "месяцев",
	'more': "Больше",
	'lessThanMonth': "Меньше месяца",
	'markAllAsRead': "Отметить все как прочитанные",
	'orders': "Заказы",
	'techSupportShort': "Тех. поддержка",
	'exchangePageName': "Биржа",
	'tickets': "Заказы",
	'statistics': "Статистика",
	'finances': "Финансы",
	'tasks': "Задачи",
	'clients': "Клиенты",
	'managers': "Менеджеры",
	'logs': "Логи менеджеров",
	'authors': "Авторы",
	'sites': "Сайты",
	'workTypes': "Типы работ",
	'templateAnswers': "Шаблонные ответы",
	'scheduledTasks': "Задачи",
	'all': "Все",
	'clean': "Очистить",
	'reason': "Причина",
	'deleted': "В корзине",
	'notDone(many)': "Актуальные",
	'sort': "Сортировка",
	'tasksCalendar': "Календарь задач",
	'languages': "Языки",
	'accessDenied': "Доступ запрещён",
	'addPhoto': "Добавьте фото",
	'male': "Мужчина",
	'female': "Женщина",
	'searchByOrderName': "Поиск по названию",
	'addOrder': "Добавить заказ",
	'doYouWantToRejectOrder': "Вы собиретесь откзаться от заказа",
	'yourPersonalManager': "Ваш личный менеджер",
	'requestAnotherManager': "Запросить другого менеджера",
	'writeReason': "Опишите причину",
	'profileEditing': "Редактирование профиля",
	'changePhoto': "Изменить фото",
	'deletePhoto': "Удалить фото",
	'chatWithYourManager(p1)': "Чат с вашим",
	'chatWithYourManager(p2)': "Менеджером",
	'chatByOrder': "Чат по заказу",
	'search': "Поиск",
	'copywriter': "Автор",
	'admin': "Администратор",
	'successNotification': "Успешно",
	'dangerNotification': "Внимание",
	'errorNotification': "Ошибка",
	'fieldFilledIncorrect': "Поле заполнено некорректно",
	'rescheduleReason': 'Причина переноса дедлайна',
	'authorRequest': 'По просьбе автора',
	'noAuthorResponse': 'Автор не отвечает',
	'clientRequest': 'По просьбе клиента',
	'noClientResponse': 'Клиент не отвечает',
	'orderUnderQaReview': 'Заказ на проверке у QA',
	'delayedCustomerPayment': 'Задержка оплаты от клиента',
	'revisionsDelayedDeadline': 'Корректировки затянули основной дедлайн',
	'shortTaskDeadline': 'Короткий дедлайн для этого задания',

	// --------------- V2
	'newMessagesCountDisplay': "Новых",
	'logout': "Выйти",
	'english': "Английский",
	'russian': "Русский",
	'german': "Немецкий",
	'french': "Французкий",
	'locale': "Язык",
	"sunday": "Воскресение",
	"monday": "Понедельник",
	"tuesday": "Вторник",
	"wednesday": "Среда",
	"thursday": "Четверг",
	"friday": "Пятница",
	"saturday": "Суббота",
	"sundayShort": "вс",
	"mondayShort": "пн",
	"tuesdayShort": "вт",
	"wednesdayShort": "ср",
	"thursdayShort": "чт",
	"fridayShort": "пт",
	"saturdayShort": "сб",
	"january": "Январь",
	"february": "Февраль",
	"march": "Март",
	"april": "Апрель",
	"may": "Май",
	"june": "Июнь",
	"july": "Июль",
	"august": "Август",
	"september": "Сентябрь",
	"october": "Октябрь",
	"november": "Ноябрь",
	"december": "Декабрь",
	"januaryGenitive": "Января",
	"februaryGenitive": "Февраля",
	"marchGenitive": "Марта",
	"aprilGenitive": "Апреля",
	"mayGenitive": "Мая",
	"juneGenitive": "Июня",
	"julyGenitive": "Июля",
	"augustGenitive": "Августа",
	"septemberGenitive": "Сентября",
	"octoberGenitive": "Октября",
	"novemberGenitive": "Ноября",
	"decemberGenitive": "Декабря",
	// --------------- end V2

	// --------------- V3
	"newtonsLaw": "Закон Ньютона",
	"topic": "Тема",
	"finished": "Завершенные",
	"stages": "Этапы",
	"confirmUploading": "Подтвердить загрузку",
	"fileDeletedSuccessfully": "Файл успешно удален",
	"fileDeletionError": "Возникла ошибка при попытке удалить файл",
	"isConfirmingStage": "Этап сейчас на подтверждении менеджера",
	"changeTemplateAnswer": "Изменить шаблонный ответ",
	"pages": "{n} страниц | {n} страница | {n} страницы | {n} страниц",
	"doYouWantToDeleteAuthorFromOrder": "Вы собираетесь удалить автора с заказа",
	"doYouWantToDeleteFile": "Вы собираетесь удалить файл",
	"youDeletedAuthorFromOrder": "Вы удалили автора с этого заказа",
	"noDataAvailable": "Данных не найдено",
	"secondsAgo": "0 Секунд назад | {n} Секунда назад | {n} Секунды назад | {n} Секунд назад",
	"minutesAgo": "0 Минут назад | {n} Минута назад | {n} Минуты назад | {n} Минут назад",
	"hoursAgo": "0 Часов назад | {n} Час назад | {n} Часа назад | {n} Часов назад",
	"daysAgo": "0 Дней назад | {n} День назад | {n} Дня назад | {n} Дней назад",
	"yearsAgo": "0 Лет назад | {n} Год назад | {n} Года назад | {n} Лет назад",
	"justNow": "Сейчас",
	// --------------- end V3

	// --------------- V4
	"writeMessageToAuthor": "Написать автору",
	"writeMessageToClient": "Написать клиенту",
	"chatWithAuthor": "Чат с автором",
	"chatOpenTooLong": "Чат был открыт слишком долго. Пожалуйста, войдите снова, чтобы продолжить общение.",
	"createSuborder": "Субзаказ",
	// --------------- end V4

	"exchange": {
		'name': 'Тема',
		'area': 'Предмет',
		'type': 'Тип',
		'page': 'Страниц',
		'stage': 'Этапов',
		'price': 'Цена',
		'price_junior_middle': "Цена для Junior/Middle",
		'price_senior': "Цена для Senior",
		'deadline': 'Дедлайн',
		'accept': 'Взять в работу',
		'decline': 'Отклонить',
		'confirmAction': 'Подтвердите действие',
		'confirmActionText': 'Вы собираетесь взять в работу этот заказ.',
		'confirmActionTextFalse': 'Вы собираетесь отклонить приглашение на этот заказ.',
		'confirmPopup': 'Подтвердить',
		'order': 'Заказ',
		'countStages': 'Кол-во этапов',
		'nameWork': 'Тема',
		'workTheme': 'Тема работы',
		'subject': 'Предмет',
		'typeWork': 'Тип работы',
		'levelQuality': 'Уровень качества',
		'countPages': 'Количество страниц',
		'attachFile': 'Прикрепленные файлы',
		'langWork': 'Язык выполнения',
		'comment': 'Комментарий',
		'getToWork': 'Приступить!',
		'filter': 'Фильтр',
		'searchToName': 'Поиск по названию',
		'level': 'Уровень',
		'off': 'От',
		'to': 'До',
		'reset': 'Сбросить',
		'inviteDecline': 'Приглашение отклонено',
		'inviteDeclineText': 'Вы успешно отклонили приглашение. Вы все еще сможете отправить заявку на выполнение этого заказа, если передумаете.',
		'inviteAccept': 'Приглашение принято',
		'inviteAcceptText': 'Спасибо, можете приступать к работе.',
		'requestSend': 'Заявка отправлена',
		'requestSendText': 'Спасибо, мы получили вашу зявку. Менеджер скоро ее подтвердит. Пожалуйста, подождите',
		'success': 'Успешно',
		'successText': 'Успешно выполнено',
		'deleteText': 'Успешно удалено',
		'acceptText': 'Успешно добавлено',
	},
	"stats": {
		"junior": 'Economy',
		"middle": 'Business',
		"senior": 'Academic',
		"income": 'Доход',
		"total": 'Net',
		"totalIncome": 'Доход',
		"privateIncome": 'Личный доход',
		"sitesCount": 'Сайтов',
		"paidOrdersCount": 'Оплаченных',
		"waitingOrdersCount": 'Повисшие',
		"graphIncome": 'Личный доход',
		"graphOrders": 'Заказы',
		"graphIncomeGlobal": 'Доход',
		"graphOrdersPaid": '"Повисшие" заказы',
		"completeOrder": 'Выполненные',
		"successOrder": 'Успешность',
		"today": 'Сегодня',
		"yesterday": 'Вчера',
		"currentWeek": 'Текущая неделя',
		"prevWeek": 'Прошлая неделя',
		"current_month": 'Текущий месяц',
		"last_month": 'Прошлый месяц',
		"last_three_month": '3 месяца',
		"last_six_month": 'Пол года',
		"last_year": 'Год',
		"all_time": 'За все время',
		"active": "Активных заказов",
		"clientsCount": 'Клиентов',
		"authorsCount": 'Авторов',
		"managersCount": 'Менеджеров',
		"salesManagers": 'Продажи менеджеров',
		"salesSites": 'Продажи по сайтам',
		"totalPaymentsForPeriod": 'Всего оплат за период',
		"totalPaidForPeriod": 'Всего оплачено за период',
		"incomeTotal": 'Gross',
		"incomeClean": 'Net',
		"ordersCount": 'Всего заказов',
		"graphUsers": 'Новые пользователи',
		"graphQualityLevels": 'Заказы по уровням качества',
		"graphSubjects": 'Заказы по предметам',
		"graphAdminIncome": 'Соотношение прибыли',
		"newPaidTickets": 'Заказы',
		"completedTickets": 'Статусы завершенных заказов',
		"conversion": 'Конверсия',
		"date": 'Дата',
		"manager": 'Менеджер',
		"clients": 'Клиенты',
		"authors": 'Авторы',
		"mangers": 'Менеджеров',
		"graph_new": 'Новых заказов',
		"paid": 'Оплаченных заказов',
		"completed": 'Выполнено',
		"failed": 'Провалено',
    "countOfRefunds": "Количество возвратов",
    "sumOfRefunds": "Сумма возвратов",
    "penalties": "Штрафы",
    "manualCredits": "Ручные зачисления",
    "fails": "Провалы",
    "countOfFails": "Количество провалов",
    "leeds": "Лиды"
	},
	"changePrice": "Изменить цену",
	"indicateThePrice": "Укажите цену",
	"priceChangedSuccessfully": "Цена успешно изменена",
	"searchById": "Поиск по ID",
	"wrongField": "Не верно указано поле",
	"forThisDay": "На сегодняшний день",
	"№": "№",
	"plagiatPercentage": "Процент плагиата",
	"reportFile": "Файл отчета",
	"markAsRead": "Отметить как прочитанное",
	"archive": "Архив",
	"chat": "Чат",
	"info": "Информация",
	"milestoneId": "ID этапа",
	"milestonePosition": "Этап",
  "comments": "Комментарии",
  "view": "Просмотр",
  "changeBalance": "Изменить баланс",
  "balanceIn": "Добавить",
  "balanceOut": "Списать",
  "paymentAmount": "Размер выплаты",
  "workIsPaidCanContinue": "Клиент оплатил эту часть, можете писать.",
  "workIsNotPaidWait": "Клиент еще НЕ оплатил эту часть, пожалуйста, ожидайте сообщения менеджера, что бы начать над ней работу.",
  "assignAnOrder": "Закрепить заказ",
  "externalEmails": "Дополнительные почты",
	"priceForMiddle": "Цена для Middle",
	"unreadMessages": "Не прочитанные смс",
  "markAsProblem": "Отметить как проблемный",
  "problemAuthor": "Проблемный автор",
  "authorMarkedAsProblem": "Автор отмечен как проблемный",
  "otherProfiles": "Другие профили",
  "refund": "Возврат",
  "refunds": "Возвраты",
  "refundReasons": "Причины возвратов",
	'indicateRefundReason': "Укажите причину возврата",
  "penalty": "Штраф",
	"needPenalty": "Требуется штраф?",
	"lateness": "Задержка",
	"authorsRequest": "Запрос автора",
	"unableToCompleteOrder": "Невозможно завершить заказ",
	"other" : "Другое",
	"instructionsNotFollowed" : "Не соблюдены инструкции",
	"plagiarism" : "Плагиат",
	"AI" : "ИИ",
	"reassignReason": "Причина для переназначения",
	"qualityIssue": "Проблемы с качеством",
	"reassign": "Переназначить",
	"reassignAuthor": "Переназначить автора",
	"requiredField": "Это обязательное поле",
	"chooseAuthorReassignReason": "Пожалуйста, выберите причину, по которой вы переназначаете этого автора",
	"shareDetailsAboutReassign": "Пожалуйста, поделитесь более подробной информацией о причине переназначения автора",
	"warning": "Предупреждение",
  "penaltySum": "Сумма штрафа",
	"uploadWarning": "Успешно загружено {success} из {total} файлов.",
  "penaltiesSum": "Сумма штрафов",
  "sumOfRefunds": "Сумма возврата",
  "choosePenaltyReason": "Укажите причину штрафа",
  "penaltyAmount": "Размер штрафа",
  "penaltyReason": "Причина штрафа",
  "penaltyCount": "Количество штрафов",
  "pricePerPage": "Цена за страницу",
  "operation": {
    "title":"Операция",
    "in":"Добавлено",
    "out":"Списано",
  },
  "amountOfIncome": "Сумма поступлений",
  "confirmPaymentManually": "Подтвердить оплату в ручную",
	"accountant": "Бухгалтер",
  "marginality": "Маржинальность",
  "marginalityConfirmationText": "Маржинальность ниже минимальной требуемой (гонорар автора слишком высокий). Вы уверены в корректности информации?",
  "failsReasons": "Причины провалов",
  "marginalityWarning": 'ВНИМАНИЕ: МАРЖИНАЛЬНОСТЬ НИЖЕ НОРМЫ',
  "orderPriceIncorrectWarning": "ВНИМАНИЕ: ЦЕНА ОТЛИЧАЕТСЯ ОТ РЕКОМЕНДУЕМОЙ БОЛЕЕ ЧЕМ НА 10%",
  "confirmPayment": "Подтвердите оплату",
  "totalActions": "Количетсов действий",
  "wordsCount": "Кол-во слов",
  "downloadActs": "Загрузить акты",
  "answerTime": "Время ответа",
  "replyTypes": "Тип ответа",
  "minutesShort": "мин.",
  "averageAnswerTimeBy": "Среднее время ответа, минут",
  "averageAnswerTime": "Среднее время ответа",
  "noAnswer": "Нет ответа",
  "authorDidNotChooseMainBankCard": "Автор не выбрал основную карту",
  "youDidNotChooseMainBankCard": "Вы не выбрали основную карту",
  "bankCards": "Банковские карты",
  "updateCardsList": "Обновить список карт",
  "toUpdateCardsListYouMustToWait": "Что бы обновить список карточек, вам нужно подождать {n} мин.",
  "bankCardsFromSolarStaff": "Банковские карты (получены из solar-staff)",
	'updatedSuccessfully': "Успешно обновлено",
	"stagesTotal": "Этапы (всего)",
  "check": "Проверить",
  "fileWillBeCheckedAsSoonAsPossible": "Файл будет проверен в ближайшее время",
  "activeOrdersCount": "Количество активных заказов",
  "activeOrders": "Активные заказы",
  "orderId": "Номер заказа",
  "group": 'Группа',
  "doNotNotifyClient": "Не уведомлять клиента",
  'searchByName': 'Поиск по названию',
  'emptyList': 'Список пустой',
  "totalLeadsByPeriod": "Всего заказов за период",
  "totalPayedLeadsByPeriod": "Всего оплачено заказов за период",
  "ignoreSpam": "Не учитывать спам",
  "conversionPercent": "Процент конверсии",
  "maxValue": "Максимальное значение {n}",
  "fieldRequired": "Поле обязательное",
  "minLength": "минимум {n}",
  "maxLength": "максимум {n}",
  "utm": {
    "matchtype":"Match type",
    "gclid":"GCLID",
    "wbraid":"WBRAID",
    "gbraid":"GBRAID",
    "fbclid":"FBCLID",
    "utm_medium":"UTM medium",
    "utm_source":"UTM source",
    "utm_term":"UTM Term",
    "utm_campaign":"UTM Campaign",
    "adgroupid":"Ad group ID",
    "targetid":"Target ID",
    "orderSource": "Источник заказа",
    "source": "Source",
    "search_word": "Search word",
    "cid": "CID",
    "geo": "GEO",
    "medium": "Medium",
    "browser_agent": "Browser agent",
    "sid": "SID",
    "sct": "SCT"
  },
	"skipReminders": "Не отправлять напоминания",
	"contactTimeReminders": "Напоминание о контакте",
	"doNotDeleteOrderAfterEmails": 'Не удалять заказ после писем',

	"uploadAuthorFilesInstruction": "Пожалуйста, пришлите работу в чат с менеджером",
	"downloadAuthorsFiles": "Загрузить файлы автора",
	"qualityAssurance": "Обеспечение качества",
	"problemsWithQuality": "Проблемы качества",
	"quality": "Качество",
	"sendpulse": {
		"resubscriptionRequested": "Запрос на повторную подписку отправлен. Клиент не получает сообщение от CRM, пока не примет его. Если это занимает слишком много времени или есть что-то срочное, воспользуйтесь почтой сайта напрямую для связи с клиентом. Клиент отписался в: {unsubscribe_date}",
		"unsubscribed": "Клиент отписался от писем, отправленных через sendpulse. В настоящее время они не получают сообщения от CRM. В случае острой необходимости необходимо воспользоваться непосредственно почтой сайта. Если клиент отправит нам сообщение, запрос на повторную подписку будет отправлен автоматически. Клиент отписался в: {unsubscribe_date}",
	},
	"authorDeadline": "Author deadline",
	"deadlineCalculatedApproximately": "Until the customer has paid for next milestones the deadline is calculated approximately. The final deadline for the milestone will be displayed once the customer approves the previous milestone and pays for the next.",
	"offerSent": "Офер отправленно",
	"guidesHint": "This is a page dedicated to collecting all out policies in one place. Here you'll find everything you need to successfully work on our platform.",
	"policiesAndGuides": "Policies & guides",
	"howToUse": "Policies and guides",
	"contactViaWhatsapp": "Contact via Whatsapp",
	"contactPhone": "Phone",
	'contactTime': "Время для связи",
	"changeStatus": "Change status",
	"forceChangeStatus": "Change ticket status without any additional notifications or related logics. Note!!! it can affect ticket workflow",
	"ticketStatus": "Ticket status",
	"activeMilestone": "Active stage",
	"activeMilestoneStatus": "Active stage status",
	"globalSettings": "System settings",
	"systemSettings": {
		"create_order_new_email": "Create order from first email from new client"
	},
	"systemSettingsGroup": {
		"main": "General"
	},
	"authorHint" : "Please upload the file in .doc or .docx format (unless requested otherwise by the customer)<br>Make sure that your file does not contain any metadata about you. Here's a guide how to <a href='https://criticalfault.com/blog/how-to-remove-metadata-from-word-documents/' target='_blank'>remove metadata</a> from your document"
	// "Ticket": "Тикет",
	// "Assign": "Назначить",
	// "Delete": "Удалить",
	// "Choose a manager": "Выберите менеджера",
	// "entrance": "Вход",
	// "Welcome back! Please login to your account": "С возвращением! Пожалуйста, войдите в свой аккаунт",
	// "Password": "Пароль",
	// "Password recovery": "Востановление пароля",
	// "registration": "Регистрация",
	// "Attempt to login": "Попытка входа в систему",
	// "You are already signed in": "Вы уже вошли в систему",
	// "Fill out the form below to create a new account": "Заполните форму ниже, чтобы создать новую учутную запись",
	// "Enter your email and we will send you a new password": "Введите свой email и мы отправим вам новый пароль",
	// "Go to login page": "На страницу входа",
	// "Successfully": "Успешно",
	// "Success": "Успешность",
	// "Profile": "Профиль",
	// "Nickname": "Никнейм",
	// "for payments": "для выплат",
	// "Telephone": "Телефон",
	// "Date of Birth": "Дата рождения",
	// "Tongue": "Язык",
	// "About myself": "О себе",
	// "Change photo": "Изменить фото",
	// "Delete photo": "Удалить фото",
	// "old password": " Старый пароль",
	// "Add to": " Добавить",
	// "Confirm deletion": "Подтвердите удаление",
	// "Are you going to delete": "Вы собираетесь удалить",
	// "Create registration link": "Создание ссылки для регистрации",
	// "Create a": "Создать",
	// "Link to registration form": "Ссылка на форму регистрации",
	// "Floor": "Пол",
	// "Technical": "Технический  ",
	// "A country": "Страна  ",
	// "Change manager request": "Запрос на смену менджера",
	// "New manager": "Новый менеджер",
	// "Confirm": "Подтвердить",
	// "Reject": "Отклонить",
	// "Client editing": "Редактирование клиента",
	// "Surname": "Фамилия",
	// "New password": "Новый пароль",
	// "Save": "Сохранить",
	// "Cancel": "Отменить",
	// "Change the type of work": "Изменить тип работы",
	// "Add work type": "Добавить тип работы",
	// "Successfully remotely": "Успешно удаленно",
	// "Successfully changed": "Успешно измененно",
	// "Total number of tickets": "Общее количество тикетов",
	// "Active tickets": "Активный тикетов",
	// "Income": "Доход",
	// "Money transferred": "Переведено денег",
	// "Total number of orders": "Общее количество заказов",
	// "Active orders": "Активных заказов",
	// "Additional": "Дополнительный ",
	// "Edit": "Редактировать ",
	// "A request has been sent to change the manager": "Отправлен запрос на смену менеджера ",
	// "Search by name.": "Поиск по имени.",
	// "Add case.": "Добавить дело.",
	// "Description": "Описание",
	// "Performed": "Выполнено",
	// "Added successfully": "Успешно добавленно",
	// "Money": "Деньги",
	// "Editing a manager": "Редактирование менеджера",
	// "Email for payments": " Email для выплат",
	// "Order successfully created": "Заказ успешно создан",
	// "Is being discussed": "Обсуждается",
	// "date of creation": "Дата создания",
	// "Name": "Название",
	// "Author": "Автор",
	// "Region": "Область",
	// "Level": "Уровень",
	// "Deadline": "Дедлайн",
	// "Pages": "Страниц",
	// "nature": "природе",
	// "Waiting for a response": "Ожидает ответа",
	// "Answer received": "Ответ получен",
	// "Appeal status": "Статус обращения",
	// "Write a message": "Написать",
	// "Closed": "Закрыто",
	// "Close appeal": "Закрыть обращение",
	// "Open a new ticket": "Открыть новое обращение",
	// "Message text": "Текст обращения",
	// "Send message": "Отправить",
	// "Message subject": "Тема сообщения",
	// "Upload a photo ": "Загрузить фото",
	// "Total works": "Всего работ",
	// "Current works": "Текущих работ",
	// "Favorites": "Избранные",
	// "Refuse to work": "Отказаться от работы",
	// "The client is not responding": "Клиент не отвечает",
	// "Technical support": "Техподдержка",
	// "Data saved": "Данные сохранены",
	// "room": "Номер",
	// "Subject of the appeal": "Тема обращения",
	// "Last Reply": "Последний ответ",
	// "Contractor applications": "Заявки исполнителей",
	// "CTo invite": "Пригласить",
	// "Select": "Выбрать",
	// "Payment details": "Детали оплаты",
	// "Approve": "Утвердить",
	// "Submit for approval": "Отправить на утверждение",
	// "Failed": "Провалено",
	// "You are about to complete the order": "Вы собираетесь завершить заказ",
	// "This action is irreversible": "Данное действие необратимое",
	// "Selected author to order": "Выбран автор на заказ",
	// "Data has been sent for approval": "Данные отправленны на утверждение",
	// "Data sent for client approval": "Данные отправленные на утверждение клиенту",
	// "Thank you, we have received your application": "Спасибо, мы получили вашу заявку",
	// "You are about to refuse an order": "Вы собираетесь отказаться от заказ",
	// "English": "Английский",
	// "Diploma": "Диплом",
	// "Natural Sciences": "Естественные науки",
	// "Client Email": "Email Клиента",
	// "Newton's law": "Закон Ньютона",
	// "Create order": "Создание заказа",
	// "Add stage": "Добавить этап",
	// "Invitations sent": "Приглашения отправленны",
	// "Add a ticket": "Добавить тикет",
	// "Search by name and client": "Поиск по названию и клиенту",
	// "Case review": "Просмотр дела",
	// "Confirmed": "Подтверждается",
	// "In processing": "В обработке",
	// "Awaiting payment": "Ожидает оплаты",
	// "Searching for an artist": "В поиске исполнителя",
	// "In the process": "В процессе",
	// "Completed": "Выполненный",
	// "Not executed with payment": "Не выполнен c выплатой",
	// "Pending consideration": "Ожидает рассмотрения",
	// "Paid out": "Выплачено",
	// "Rejected": "Отклонено",
	// "Reject payment": "Отклонить платеж",
	// "Reason for declining payment": "Причина отклонения платежа",
	// "Current balance": "Текущий баланс",
	// "Withdraw": "Вывести",
	// "Pay out": "Выплатить",
	// "the amount you host withdraw": "сумму Вы хостите вывести",
	// "Transaction ID": "ID транзакция",
	// "Payment system": "Платежная система ",
	// "Payment requests": "Запросы на выплату",
	// "History for payments": "История для выплат",
	// "Declined payments": "Отклоненные выплаты",

};
